import { Flex, InkTag } from "@/atoms"
import { InformationPopover } from "@/molecules/InformationPopover"

import type { ApplicationInkTagProps } from "."

export const ApplicationInkTag = (props: ApplicationInkTagProps) => {
  const { className, count, type, lastSeenUserLocale, lastSeenRelative, t } =
    props
  const date = lastSeenUserLocale || lastSeenRelative
  const showPopover = !!date && !!t

  if (props.onlyInkTag) return <InkTag dot size="small" className={className} />

  return (
    <InformationPopover.Popover
      destroyOnHidden
      open={showPopover ? undefined : false}
      content={
        showPopover && (
          <InformationPopover.CommonTemplate
            title={t(`inventory.application.statuses.description.${type}`)}
          >
            {type === "active" && (
              <span>{`${t("general.lastSeen")} ${lastSeenRelative}`}</span>
            )}
            {type === "inactive" && (
              <span>{`${t("general.lastSeen")} ${lastSeenRelative}`}</span>
            )}
            {type === "terminated" && <span>{`On ${lastSeenUserLocale}`}</span>}
          </InformationPopover.CommonTemplate>
        )
      }
    >
      <Flex gap={8} align="center">
        <InkTag dot size="small" className={className} />
        <Flex gap={6} align="center" className="wrapper-application-ink-tag">
          {Number.isInteger(count) && <span>{count}</span>}
          <span className="capitalize-text-ks">{type}</span>
        </Flex>
      </Flex>
    </InformationPopover.Popover>
  )
}
